"use client";
import React, { useRef } from "react";
import Image from "next/image";
import styles from "./index.module.scss";
import SubmitFeedback from "../SubmitFeedback";
import EmptyImage from "../../assets/empty-404.png";
import { isMobile } from "react-device-detect";
import classNames from "classnames";

const Empty = ({ job_search_empty, searchParams, config, dictionary }: any) => {
  const container = useRef(null);

  return (
    <div className={classNames(styles.emptyContainer, "yolo-empty-container")}>
      <div ref={container} className={styles.jsonContainer}>
        <Image src={EmptyImage} alt='empty' width={100} height={100} />
      </div>

      <div className={styles.description}>
        <SubmitFeedback
          job_search_empty={job_search_empty}
          searchParams={searchParams}
          config={config}
          dictionary={dictionary}
        />
      </div>
    </div>
  );
};

export default Empty;
